/*
 *    ____            _           _____
 *   / ___|    ___   | |   ___   |_   _|   ___    _ __    _   _
 *   \___ \   / _ \  | |  / _ \    | |    / _ \  | '_ \  | | | |
 *    ___) | | (_) | | | | (_) |   | |   | (_) | | | | | | |_| |
 *   |____/   \___/  |_|  \___/    |_|    \___/  |_| |_|  \__, |
 *  Created by Antonio Solo                               |___/
 *  Project & copyright: NSB.SU
 *
 */

import {CONSTANTS} from '@/constants';
import {functions} from '@/functions';
import miniToastr from "mini-toastr";

export const functions_payments = {

    data: function () {
        return {
            payment: null,
        };
    },

    methods: {

        /*
         *  Платежи
         */

        uploadPayments: function (xml_data, onSuccess=null, param=null) {
            let formdata = new FormData();
            formdata.append('data', xml_data.data);
            formdata.append('file', xml_data.file);
            this.httpPrepare();
            this.$http.post(this.apiurl('payment/upload'), formdata, { headers: { 'Content-Type': 'multipart/form-data'} }).then(function (response) {
                response = this.httpSuccess(response);
                this.upload_result = response.payload;
                this.executeFunction(onSuccess, param);
            },this.httpError)
        },


        /*
         *  Платеж
         */

        createPayment: function (payment_info, onSuccess=null, param=null) {
            payment_info.document_date = dateToISO(payment_info.document_date);
            payment_info.statement_date = dateToISO(payment_info.statement_date);
            payment_info.invoice_date = dateToISO(payment_info.invoice_date);
            this.httpPrepare();
            this.$http.post(this.apiurl('payment/create'), {payment_info:payment_info}).then(function (response) {
                response = this.httpSuccess(response);
                if (response.result === 'success') {
                    console.log(response);
                    this.executeFunction(onSuccess, param);
                }
                else {
                    this.error_log(response.error);
                }
            },function (error) {
                this.error_log(error);
            })
        },

        isPaymentLoaded: function () {
            return (this.payment !== null) && this.payment;
        },

        resetPayment: function () {
            this.payment = null;
            return this;
        },

        loadPayment: function (payment_id, onSuccess = null, param = null) {
            console.log('loadPayment');
            if (!this.isPaymentLoaded() && payment_id) {
                this.payment = null;
                this.httpPrepare();
                let self=this;
                this.$http.get(this.apiurl('payment/' + payment_id)).then(function (response) {
                    response = this.httpSuccess(response);
                    self.payment = response.payload;
                    this.executeFunction(onSuccess, param, response.payload);
                }, this.httpError)
            }
            return this;
        },

        updatePaymentBindings: function (payment_id, bindings, onSuccess=null, onError=null) {
            if (payment_id) {
                console.assert(FALSE)
                // let self = this;
                // this.payment = null;
                // this.httpPrepare();
                // this.$http.put(this.apiurl('payment/' + payment_id + '/ex-cancel' )).then(function (response) {
                //     response = this.httpSuccess(response);
                //     self.payment = response.payload;
                //     if (response.result==='success') {
                //         miniToastr["success"]('Отмена выполнена', null, CONSTANTS.TOAST_SUCCESS_LIFETIME);
                //         this.executeFunction(onSuccess, param);
                //     }
                //     else {
                //         miniToastr["error"]('При выполнении отмены произошла ошибка: ' + response.error, null, CONSTANTS.TOAST_ERROR_LIFETIME);
                //         this.executeFunction(onError, param);
                //     }
                // }, function (error) {
                //     this.httpError(error);
                //     this.executeFunction(onError, param);
                // })
            }
            return this;
        },

        getTypesForSystem: function () {
            return [
                {'id':3, 'title':CONSTANTS.PAYMENT_TYPE_TEXT[3]},
                {'id':4, 'title':CONSTANTS.PAYMENT_TYPE_TEXT[4]},
                {'id':5, 'title':CONSTANTS.PAYMENT_TYPE_TEXT[5]},
                {'id':6, 'title':CONSTANTS.PAYMENT_TYPE_TEXT[6]},
                {'id':7, 'title':CONSTANTS.PAYMENT_TYPE_TEXT[7]},
                {'id':8, 'title':CONSTANTS.PAYMENT_TYPE_TEXT[8]},
                {'id':9, 'title':CONSTANTS.PAYMENT_TYPE_TEXT[9]},
                {'id':10, 'title':CONSTANTS.PAYMENT_TYPE_TEXT[10]},
            ];
        },

        getPaymentTypeName: function (id) {
            return CONSTANTS.PAYMENT_TYPE_TEXT[id];
        },

        bindBookingToPayment: function (payment_id, booking_id, amount, onSuccess=null, param=null) {
            if (payment_id) {
                let safe_booking = this.booking;
                this.booking = null;
                let self = this;
                let binding_info = {
                    booking_id: booking_id,
                    amount: amount
                };
                this.httpPrepare();
                this.$http.put(this.apiurl('payment/' + payment_id+ '/bind'), binding_info).then(function (response) {
                    response = this.httpSuccess(response, true, 'Платеж привязан к брони');
                    if (response.result === 'success') {
                        self.payment = response.payload;
                        this.executeFunction(onSuccess, param);
                    }
                    // else {
                    //     this.error_log(response.error);
                    //     miniToastr["error"](response.error, null, 15000);
                    // }
                },function (error) {
                    this.httpError(error);
                })
            }
            return this;
        },

        unbindBookingToPayment: function (payment_id, booking_id, pbrel_id, onSuccess=null, param=null) {
            if (payment_id) {
                let safe_booking = this.booking;
                this.booking = null;
                let self = this;
                let unbinding_info = {
                    booking_id: booking_id,
                    pbrel_id: pbrel_id
                };
                this.httpPrepare();
                this.$http.put(this.apiurl('payment/' + payment_id + '/unbind'), unbinding_info).then(function (response) {
                    response = this.httpSuccess(response, true, 'Платеж отвязан от брони');
                    if (response.result === 'success') {
                        self.payment = response.payload;
                        this.executeFunction(onSuccess, param);
                    }
                    // else {
                    //     this.error_log(response.error);
                    // }
                },function (error) {
                    this.httpError(error);
                    this.error_log(response.error);
                })
            }
            return this;
        },

    },
};
